import { useMemo, useSyncExternalStore } from 'react';
import { getActiveLocale, subscribeToActiveLocale, switchLocale } from '../active-locale';
import { getLocaleMessages } from '../locale-catalogue';
import { DEFAULT_LOCALE, LOCALES } from '../locales-config';

const localeOptions = Object.values(LOCALES);

// The SPA shell is prerendered in the default locale, so hydration must start from it too
const getServerLocale = () => DEFAULT_LOCALE;

export function useLocales() {
  const locale = useSyncExternalStore(subscribeToActiveLocale, getActiveLocale, getServerLocale);
  const messages = useMemo(() => getLocaleMessages(locale), [locale]);

  return useMemo(() => ({ locale, localeOptions, messages, switchLocale }), [locale, messages]);
}
